import { render, staticRenderFns } from "./UpdateSchedule.vue?vue&type=template&id=41373881&scoped=true"
import script from "./UpdateSchedule.vue?vue&type=script&lang=js"
export * from "./UpdateSchedule.vue?vue&type=script&lang=js"
import style0 from "./UpdateSchedule.vue?vue&type=style&index=0&id=41373881&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41373881",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41373881')) {
      api.createRecord('41373881', component.options)
    } else {
      api.reload('41373881', component.options)
    }
    module.hot.accept("./UpdateSchedule.vue?vue&type=template&id=41373881&scoped=true", function () {
      api.rerender('41373881', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/UpdateSchedule.vue"
export default component.exports